import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { MercadoFilter } from '../filter';
import { Mercado } from '../mercado';

@Injectable({
    providedIn: 'root'
})
export class MercadoTypeaheadHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/mercado`
    }

    /** Pesquisa os mercados para o typeahead */
    search(filter: MercadoFilter, limit: number): Observable<Mercado[]> {
       // Params
       let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);

        return this.customHttp.get<Mercado[]>(this.pathApi, {params});
    }
}
